export default __webpack_public_path__ + "media/Bamboo_mobile.4185820945e1b99876e9d23e5410bf6e.svg";